import { Mediator } from "modular-openscriptjs";
import { gc, dc } from "../ojs.contexts";
import { api, STRINGS, uc } from "../declarations";
import { inform, saveUser } from "../helpers";
import { loadGoogleMaps } from "../google-maps";
import { $e } from "../ojs.events";

export default class System extends Mediator {
  $$system = {
    booted: async () => {
      await this.loadAppConfigs();

      loadGoogleMaps(import.meta.env.VITE_GOOGLE_MAPS_KEY);

      gc.appLoaded.value = true;
      gc.appLoadedAt.value = (new Date()).getTime();

      this.send($e.app.loaded);
      this.fetchNotificationCount();
    },

    needs: {
      configReload: async () => {
        await this.loadAppConfigs();
        gc.appConfigReloaded.value = true;
        gc.appLoadedAt.value = (new Date()).getTime();
        this.send($e.app.reloaded);
        this.fetchNotificationCount();
      },
      notificationCount: () => this.fetchNotificationCount(),
    },

    has: {
      notification: () => this.fetchNotificationCount(),
    },
  };

  async fetchNotificationCount() {
    if (!gc.auth.value || !gc.user.value?.id) return;

    try {
      const res = await api.get(
        `user/${gc.user.value.id}/notifications/count`,
      );
      if (res && res.data) {
        dc.notificationsCount.value = res.data;
      }
    } catch (e) {
      console.error("Failed to load notification counts", e);
    }
  }

  async loadAppConfigs() {
    let res = await api.get("configs");

    if (!res) {
      inform(
        "Oops! We could not open the app. Please try again.",
        STRINGS.WARNING,
        5000,
        false,
      );

      return;
    }

    let configs = res.data;

    for (let key in configs) {
      window[key] = configs[key];
    }

    gc.user.value = window.currentUser;
    gc.auth.value = window.isLoggedIn;
    await saveUser(window.currentUser);
    uc.settings.value = window.userSettings;
  }
}
